export default __webpack_public_path__ + "static/media/world.098c6a4c.svg";